import { render, staticRenderFns } from "./collaborators-dropdown.vue?vue&type=template&id=58cf2e5c"
import script from "./collaborators-dropdown.vue?vue&type=script&lang=js"
export * from "./collaborators-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports